import React, { useEffect, useState } from "react";
import Tour from "src/components/Tour";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";

import { userDontShowDialogsSelector } from "src/store/system/selector";
import DontShowThisMessageAgainCheckbox from "src/components/DontShowThisMessageAgainCheckbox";

const Key = "walk_through_pending_inventory_checker";

const Steps = [
  {
    content: (props) => (
      <>
        <DialogTitle>Pending Inventory - 1/4</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Each daily sync holds new listings here instead of adding them to
            inventory straight away. Review them before they reach your
            inventory.
          </DialogContentText>
          <DialogContentText>
            The duplicate checker looks for title matches first, then SKU
            matches.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => props.goTo(1)}
          >
            Next
          </Button>
        </DialogActions>
      </>
    ),
  },
  {
    selector: "#pending-inventory-checker-grid",
    content: (props) => (
      <>
        <DialogTitle>Pending Inventory - 2/4</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Each row compares the item already in your inventory (left) with the
            listing that was just pulled (right).
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => props.goTo(0)}
          >
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => props.goTo(2)}
          >
            Next
          </Button>
        </DialogActions>
      </>
    ),
  },
  {
    selector: "#pending-inventory-checker-actions",
    content: (props) => (
      <>
        <DialogTitle>Pending Inventory - 3/4</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Select listings with the boxes on the left, then choose “Add to
            Import” to keep them for the import step or “Remove from Import” to
            drop them and keep your existing inventory item.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => props.goTo(1)}
          >
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => props.goTo(3)}
          >
            Next
          </Button>
        </DialogActions>
      </>
    ),
  },
  {
    selector: "#pending-inventory-checker-actions",
    content: (props) => (
      <>
        <DialogTitle>Pending Inventory - 4/4</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Items you add to the import are reviewed once more before they are
            written to inventory.
          </DialogContentText>
          <DontShowThisMessageAgainCheckbox dialog={Key} />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => props.goTo(2)}
          >
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => props.close()}
          >
            Close
          </Button>
        </DialogActions>
      </>
    ),
  },
];

const useStyles = makeStyles((theme) => ({
  helper: {
    maxWidth: "80%",
    [theme.breakpoints.up("sm")]: {
      maxWidth: "500px",
    },
    padding: 0,
  },
}));

export function PendingInventoryCheckerWalkThrough() {
  const [open, setOpen] = useState(true);
  const userDontShowDialogs = useSelector(userDontShowDialogsSelector);
  const classes = useStyles();
  const isOpen =
    open && userDontShowDialogs && !userDontShowDialogs?.includes(Key);

  return (
    <Tour
      startAt={0}
      closeWithMask={false}
      disableFocusLock
      steps={Steps}
      isOpen={isOpen}
      onRequestClose={() => {
        setOpen(false);
      }}
      showButtons={false}
      showCloseButton={false}
      showNavigation={false}
      showNavigationNumber={false}
      showNumber={false}
      disableDotsNavigation
      rounded={12}
      className={classes.helper}
      disableInteraction
    />
  );
}

export default function PendingInventoryCheckerWalkThroughGate({
  loading,
}: {
  loading: boolean;
}) {
  const [render, setRender] = useState(!loading);
  useEffect(() => {
    if (loading) return;
    const timer = setTimeout(() => setRender(true));
    return () => clearTimeout(timer);
  }, [loading]);
  if (!render) return null;
  return <PendingInventoryCheckerWalkThrough />;
}
